<template>
  <div v-show="showTotal" @click="openModal('PAY_INVOICES_MODAL')" class="adminInvoiceTotalFloater">
    <span class="values">
      <h4>{{ $t('hausefulInvoices.selectedInvoiceValues') }}</h4>
      <p>{{ total }}</p>
    </span>
    <span class="body-2">
      {{ $t('hausefulInvoices.actions.payInvoices') }}
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

export default {
  name: 'ShowTotalSelectedInvoices',

  props: {
    invoices: {
      type: Array,
      required: false,
    },
  },

  watch: {
    invoices(invoices) {
      this.calculateTotal(invoices)
    },
  },

  computed: {
    showTotal() {
      return this.invoices.length > 0
    },
  },

  methods: {
    ...mapActions(['openModal']),

    calculateTotal(data) {
      const total = data.reduce((sum, item) => sum + item.total, 0)
      this.total = catalogMonetary(total ?? 0)
    },
  },

  data() {
    return {
      total: 0,
    }
  },
}
</script>

<style>
.adminInvoiceTotalFloater {
  position: fixed;
  display: flex;
  align-items: center;
  bottom: 15px;
  left: 110px;
  padding: 10px 20px;
  color: white;
  cursor: pointer;
  border-radius: 6px;
  backdrop-filter: blur(10px);
  background-color: transparent;
  box-shadow: -2px 6px 12px 0 rgba(0, 0, 0, 0.2) !important;
  transform: scale(1);
  transition: all cubic-bezier(0.075, 0.82, 0.165, 1) 0.4s;
}

.adminInvoiceTotalFloater:hover {
  transform: scale(1.05);
}

.adminInvoiceTotalFloater:active {
  transform: scale(0.95);
}

.adminInvoiceTotalFloater:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  transition: all cubic-bezier(0.075, 0.82, 0.165, 1) 4s;
  background: linear-gradient(45deg, #f9a825, #f37a76);
  opacity: 0.8;
  z-index: -1;
}

.adminInvoiceTotalFloater .values {
  display: block;
  text-align: right;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  padding: 0 15px 0 0;
}

.adminInvoiceTotalFloater .body-2 {
  display: block;
  padding: 0 0 0 15px;
  font-size: 14px;
  font-weight: bold;
  line-height: 100%;
}

.adminInvoiceTotalFloater h4 {
  line-height: 100%;
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
}

.adminInvoiceTotalFloater p {
  margin: 0;
  font-size: 26px;
  line-height: 120%;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
}
</style>
